import { render, staticRenderFns } from "./scholars.vue?vue&type=template&id=0e7cdcc4&scoped=true"
import script from "./scholars.vue?vue&type=script&lang=js"
export * from "./scholars.vue?vue&type=script&lang=js"
import style0 from "./scholars.vue?vue&type=style&index=0&id=0e7cdcc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7cdcc4",
  null
  
)

export default component.exports